
































































































































































































































































































import Vue from 'vue';
import {
  IVendor,
  Vendor,
  VendorFieldError,
  VENDOR_MAX_ID_LENGTH,
  VENDOR_MAX_STATUS_LENGTH,
  VENDOR_MAX_TERMS_LENGTH,
  VENDOR_MAX_LANGUAGE_LENGTH
} from '@/models';

import { ALForm } from '@/common/component.types';

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { ErrorManager } from '@/models/error';
import { diffDeep } from '@/utils/helpers';
import { AxiosError } from 'axios';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import CountryPicker from '../common/CountryPicker.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  components: { ErrorAlert, CountryPicker, ALDialog },

  name: 'VendorDetailFormDialog',

  data: () => ({
    loading: false,
    isEdit: false,
    dialog: false,
    currencyLoading: false,
    vendorOriginalCopy: null as null | IVendor,
    vendor: null as null | IVendor,
    fieldError: new VendorFieldError(),

    errorMessage: '',
    detailErrorMessage: '',
    isFileValid: false,

    requiredRules: [(v: string) => !!v || 'This field is required']
  }),

  mounted() {
    // fetch all currencies
    this.currencyLoading = true;
    this.fetchCurrencies()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
        this.fieldError.currency.push('Error occurred getting currencies');
      })
      .finally(() => (this.currencyLoading = false));
  },

  computed: {
    ...mapGetters({
      currencies: 'currencyNew/getCurrencies'
    }),

    fieldMaxLength(): Record<string, number> {
      return {
        VENDOR_MAX_ID_LENGTH,
        VENDOR_MAX_STATUS_LENGTH,
        VENDOR_MAX_TERMS_LENGTH,
        VENDOR_MAX_LANGUAGE_LENGTH
      };
    }
  },

  methods: {
    ...mapActions({
      fetchCurrencies: 'currencyNew/fetchCurrencies',
      createVendor: 'vendor/createVendor',
      updateVendor: 'vendor/updateVendor'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    open(vendor: IVendor = new Vendor(), isEdit = false) {
      this.clearAllErrors();
      this.vendorOriginalCopy = vendor;
      this.vendor = cloneDeep(this.vendorOriginalCopy);
      this.isEdit = isEdit;

      this.dialog = true;

      this.resetFormValidation();
    },

    close() {
      this.dialog = false;
      this.clearAllErrors();
    },

    clearAllErrors(): void {
      this.fieldError.clearErrors();
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async saveVendor(): Promise<void> {
      if (this.validateForm()) {
        this.clearAllErrors();

        this.loading = true;

        try {
          if (this.isEdit) {
            const vendorDelta = diffDeep(
              this.vendor,
              this.vendorOriginalCopy,
              true
            );
            vendorDelta!.id = this.vendor!.id;
            await this.updateVendor(vendorDelta);
          } else {
            await this.createVendor(this.vendor);
          }

          this.loading = false;

          this.close();
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (VendorFieldError.isVendorFieldError(error.response.data)) {
              this.fieldError = new VendorFieldError(error.response.data);
            } else if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }

          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.loading = false;
        }
      }
    }
  }
});
